import { render, staticRenderFns } from "./GetCouponsDialog.vue?vue&type=template&id=a6c12520&scoped=true&"
import script from "./GetCouponsDialog.vue?vue&type=script&lang=js&"
export * from "./GetCouponsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GetCouponsDialog.vue?vue&type=style&index=0&id=a6c12520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c12520",
  null
  
)

export default component.exports